import { createContext, useContext, useMemo } from 'react'
import { SearchProvider } from './SearchProvider'
import type { NavigationContextState, RootNavigationProps } from './types'
import { NavigationDrawer } from '../NavigationDrawer/NavigationDrawer'

const initialContextState: NavigationContextState = {
  hasScrollAnimation: {
    mobile: true,
    desktop: true,
  },
  searchComponent: null,
  basketComponent: null,
}

const NavigationContext =
  createContext<NavigationContextState>(initialContextState)

export const Navigation = ({
  hasScrollAnimation = initialContextState.hasScrollAnimation,
  searchComponent,
  basketComponent,
  children,
}: RootNavigationProps) => {
  const context = useMemo<NavigationContextState>(
    () => ({
      hasScrollAnimation,
      searchComponent,
      basketComponent,
    }),
    [hasScrollAnimation, searchComponent, basketComponent],
  )

  return (
    <NavigationContext.Provider value={context}>
      <SearchProvider>
        <NavigationDrawer>{children}</NavigationDrawer>
      </SearchProvider>
    </NavigationContext.Provider>
  )
}

export const useNavigationContext = () => useContext(NavigationContext)
